export default __webpack_public_path__ + "static/media/solta3.caae4476.jpg";